import React from "react"
import Typography from "@mui/material/Typography"
import {PriceParentWrapper, ProductDetailItem, ProductDetails, StatusWrapper} from "./component"
import {SalePrice} from "../../component"
import {containsEmailAddress} from "../../../../utils/stringContainsPIIData"

export type StandardMiniShoppingBagDescriptionProps = {
    ProductName: string
    Description: string
    AlternativeDescription: string
    SizeDescription: string
    Quantity: string
    StockStatus: string
    StockMessage: string
    ciStoreName: string
    PriceFormatted: string
    text: any
    IsDiscount: boolean
    saleName: string
}

export const StandardMiniShoppingBagDescription = ({
    AlternativeDescription,
    Description,
    IsDiscount,
    PriceFormatted,
    SizeDescription,
    Quantity,
    StockMessage,
    StockStatus,
    ciStoreName,
    text,
    saleName,
}: StandardMiniShoppingBagDescriptionProps) => {
    const {sizeText, qtyText, price} = text

    return (
        <ProductDetails>
            <ProductDetailItem>
                <Typography variant="body3" data-testid="header-mini-shopping-bag-item-description">
                    {AlternativeDescription || Description}
                </Typography>
                <PriceParentWrapper>
                    <Typography variant="body3" align="right">
                        {PriceFormatted}
                    </Typography>
                    {IsDiscount && (
                        <SalePrice data-testid="header-mini-shopping-bag-item-sale-price">
                            {`${saleName} ${price}`}
                        </SalePrice>
                    )}
                </PriceParentWrapper>
            </ProductDetailItem>

            <Typography variant="body1">
                {sizeText} {SizeDescription}
            </Typography>

            <Typography variant="body1">
                {qtyText} {Quantity}
            </Typography>

            <StatusWrapper
                status={StockStatus}
                data-testid="header-mini-shopping-bag-item-status"
                data-dtrum-replay-mask={containsEmailAddress(StockMessage) ? "" : null}
            >{`${StockMessage} ${ciStoreName}`}</StatusWrapper>
        </ProductDetails>
    )
}

export default StandardMiniShoppingBagDescription
